import { CommonModule, DecimalPipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { CheckboxModule } from 'primeng/checkbox';
import { ColorPickerModule } from 'primeng/colorpicker';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { DialogService, DynamicDialogConfig, DynamicDialogModule, DynamicDialogRef } from 'primeng/dynamicdialog';
import { FileUploadModule } from 'primeng/fileupload';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputSwitchModule } from 'primeng/inputswitch';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { MessagesModule } from 'primeng/messages';
import { MultiSelectModule } from 'primeng/multiselect';
import { PaginatorModule } from 'primeng/paginator';
import { PasswordModule } from 'primeng/password';
import { RadioButtonModule } from 'primeng/radiobutton';
import { RatingModule } from 'primeng/rating';
import { RippleModule } from 'primeng/ripple';
import { TableModule } from 'primeng/table';
import { TabMenuModule } from 'primeng/tabmenu';
import { TabViewModule } from 'primeng/tabview';
import { ToolbarModule } from 'primeng/toolbar';
import { MenuModule } from 'primeng/menu';
import { TooltipModule } from 'primeng/tooltip';
import { MessagesComponent } from './components/messages/message.component';
import { AccessDeniedComponent } from './components/access-denied/access-denied.component';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { AccordionModule } from 'primeng/accordion';
import { DividerModule } from 'primeng/divider';
import { PanelModule } from 'primeng/panel';
import {KeyFilterModule} from 'primeng/keyfilter';
import { SplitButtonModule } from 'primeng/splitbutton';
import { FieldsetModule } from 'primeng/fieldset';
import { SkeletonModule } from 'primeng/skeleton';
import { SidebarModule } from 'primeng/sidebar';
import { SplitterModule } from 'primeng/splitter';
import { AvatarModule } from 'primeng/avatar';
import { EditorModule } from 'primeng/editor';
import { TagModule } from 'primeng/tag';
import { BadgeModule } from 'primeng/badge';
import { CustomDateComponent } from './components/custom-fields/custom-date/custom-date.component';
import { CustomLinkComponent } from './components/custom-fields/custom-link/custom-link.component';
import { CustomNumberComponent } from './components/custom-fields/custom-number/custom-number.component';
import { CustomSingleCheckboxComponent } from './components/custom-fields/custom-single-checkbox/custom-single-checkbox.component';
import { CustomTextboxComponent } from './components/custom-fields/custom-textbox/custom-textbox.component';
import { CustomListComponent } from './components/custom-fields/custom-list/custom-list.component';
import { TimelineModule } from 'primeng/timeline';
import { CardModule } from 'primeng/card';
import { ChipModule } from 'primeng/chip';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { ScrollerModule } from 'primeng/scroller';
import { ChipsModule } from 'primeng/chips';
import { CustomRadioButtonComponent } from './components/custom-fields/custom-radio-button/custom-radio-button.component';
import { SelectButtonModule } from 'primeng/selectbutton';
import { ScrollTopModule } from 'primeng/scrolltop';
import { SpeedDialModule } from 'primeng/speeddial';
import { ChartModule } from 'primeng/chart';
import { BlockUIModule } from 'primeng/blockui';
import { SliderModule } from 'primeng/slider';
import { ProgressSpinnerModule } from 'primeng/progressspinner';

@NgModule({
  declarations: [
    MessagesComponent,
    AccessDeniedComponent,
    NotFoundComponent,
    CustomTextboxComponent,
    CustomDateComponent,
    CustomLinkComponent,
    CustomNumberComponent,
    CustomSingleCheckboxComponent,
    CustomListComponent,
    CustomRadioButtonComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ButtonModule,
    RippleModule,
    TableModule,
    FileUploadModule,
    ToolbarModule,
    RatingModule,
    InputTextModule,
    InputTextareaModule,
    DropdownModule,
    RadioButtonModule,
    InputNumberModule,
    DialogModule,
    PaginatorModule,
    CheckboxModule,
    ColorPickerModule,
    CalendarModule,
    TabViewModule,
    InputSwitchModule,
    MultiSelectModule,
    TooltipModule,
    DynamicDialogModule,
    TabMenuModule,
    PasswordModule,
    InputGroupAddonModule,
    InputGroupModule,
    MessagesModule,
    AccordionModule,
    DividerModule,
    PanelModule,
    KeyFilterModule,
    SplitButtonModule,
    FieldsetModule,
    SkeletonModule,
    SidebarModule,
    SplitterModule,
    AvatarModule,
    EditorModule,
    TagModule,
    MenuModule,
    BadgeModule,
    TimelineModule,
    CardModule,
    ChipModule,
    OverlayPanelModule,
    InfiniteScrollModule,
    ScrollerModule,
    ChipsModule,
    SelectButtonModule,
    ScrollTopModule,
    SpeedDialModule,
    ChartModule,
    BlockUIModule,
    SliderModule,
    ProgressSpinnerModule
  ],
  exports:[
    MessagesComponent,
    AccessDeniedComponent,
    NotFoundComponent,
    
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ButtonModule,
    RippleModule,
    TableModule,
    FileUploadModule,
    ToolbarModule,
    RatingModule,
    InputTextModule,
    InputTextareaModule,
    DropdownModule,
    RadioButtonModule,
    InputNumberModule,
    DialogModule,
    PaginatorModule,
    CheckboxModule,
    ColorPickerModule,
    CalendarModule,
    TabViewModule,
    InputSwitchModule,
    MultiSelectModule,
    TooltipModule,
    DynamicDialogModule,
    TabMenuModule,
    PasswordModule,
    InputGroupAddonModule,
    InputGroupModule,
    MessagesModule,
    AccordionModule,
    DividerModule,
    PanelModule,
    KeyFilterModule,
    SplitButtonModule,
    FieldsetModule,
    SkeletonModule,
    SidebarModule,
    SplitterModule,
    AvatarModule,
    EditorModule,
    TagModule,
    BadgeModule,
    CustomTextboxComponent,
    CustomDateComponent,
    CustomLinkComponent,
    CustomNumberComponent,
    CustomSingleCheckboxComponent,
    CustomListComponent,
    CustomRadioButtonComponent,
    MenuModule,
    TimelineModule,
    CardModule,
    ChipModule ,
    OverlayPanelModule,
    InfiniteScrollModule,
    ScrollerModule,
    ChipsModule,
    SelectButtonModule,
    ScrollTopModule,
    SpeedDialModule,
    ChartModule,
    BlockUIModule,
    SliderModule,
    ProgressSpinnerModule
  ],
  providers: [
    DialogService,
    DynamicDialogConfig,
    DynamicDialogRef,
    DecimalPipe
  ]
})
export class SharedModule { }
